import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import FiliadoTable from './components/FiliadoTable';
import FiliadoToolbar from './components/FiliadoToolbar/FiliadoToolbar';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { NotFound as NotFoundView } from '../index';
import { MessageValues } from '../../values/MessageValues';
import { isAuthenticated } from '../../helpers/authenticate';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import Backdrop from '@material-ui/core/Backdrop';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PrintIcon from '@material-ui/icons/Print';
import Grid from '@material-ui/core/Grid';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import DialogImpressao from './components/DialogImpressao';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
function FiliadoList({history}) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const opcoesBotaoFlutuante = [
    { icon: <PersonAddIcon />, name: 'Adicionar', acao: ((event) => openFiliadoRegister(event)) },
    { icon: <PrintIcon />, name: 'Impressão',  acao: ((event) => handleAbrirDialogImpressao(event)) },
  ];
  const [loading, setLoading] = React.useState(false);
  const [filiados, setFiliados] = useState({
    result: []
  });
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [showDialogConfirmacaoDeleteFiliado, setShowDialogConfirmacaoDeleteFiliado] = useState(false);
  const [selectedIndexFiliado, setSelectedIndexFiliado] = useState(-1);
  const [cnpjConfirmation, setCnpjConfirmation] = useState('');
  const [sucess, setSucess] = useState(true);
  const [openFiliadoChangePassword, setOpenFiliadoChangePassword] = useState(false);
  const [filiadoSelecionado, setFiliadoSelecionado] = useState({});
  const [filiacaoStatus, setFiliacaoStatus] = useState({
    result: []
  });
  const [abrirDialogImpressao, setAbrirDialogImpressao] = useState(false);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    async function carregarFiliados() {
      try{
        setLoading(true);
        const params = {
          limit: 100,
        };
        const dados = await api.get('filiados/', {params: params});
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length !== 0){
            for(let i = 0, size = dados.data.result.length; i < size; i++){
              dados.data.result[i].on_mouse_over = false;
            }
            setFiliados(dados.data);
          }
          else{
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há filiados cadastrados');
            setShowMessageSnack(true);
          }
        }
        else{
          setSucess(false);
        }

      }
      catch (e) {
        setSucess(false);

      }
    }
    carregarFiliados();
  }, []);

  useEffect(() => {
    async function carregarFiliacaoStatus() {
      try{
        setLoading(true);
        const params = {
          limit: 100,
        };
        const dados = await api.get('filiacao-status/', {params: params});
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length !== 0){
            setFiliacaoStatus(dados.data);
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Não há status para os filiados');
            setShowMessageSnack(true);
          }
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Não foi possível obter os status de fiiados. Contate o suporte.');
          setShowMessageSnack(true);
        }

      }
      catch (e) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(MessageValues.erro_catch);
        setShowMessageSnack(true);
      }
    }
    carregarFiliacaoStatus();
  }, []);

  function showConfirmationDeleteFiliado(index){
    if (selectedIndexFiliado < 0 && selectedIndexFiliado >= filiados.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o usuário');
      setShowMessageSnack(true);
    }
    else{
      setSelectedIndexFiliado(index);
      setShowDialogConfirmacaoDeleteFiliado(true);
    }

  }

  async function deleteFiliado() {
    if (selectedIndexFiliado < 0 && selectedIndexFiliado >= filiados.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o filiado');
      setShowMessageSnack(true);
    }
    else{
      try {
        setShowDialogConfirmacaoDeleteFiliado(false);
        setLoading(true);
        const id = filiados.result[selectedIndexFiliado].idFiliado;
        const dados = await api.delete(`filiados/${id}`);
        setCnpjConfirmation('');
        if (dados.data.isSuccess === true) {
          const params = {
            limit: 100,
          };
          const dados = await api.get('filiados/', { params: params });
          setLoading(false);
          if (dados.data.isSuccess === true) {
            setTypeSnack('success');
            setMessageSnack('FiliadoRegister deletado com sucesso');
            setShowMessageSnack(true);
            for (let i = 0, size = dados.data.result.length; i < size; i++) {
              dados.data.result[i].on_mouse_over = false;
            }
            setFiliados(dados.data);
          } else {
            setTypeSnack('error');
            setMessageSnack('Erro ao carregar filiados');
            setShowMessageSnack(true);
          }
        } else {
          setTypeSnack('error');
          setMessageSnack('Erro ao deletar filiado. Contate o suporte.');
          setShowMessageSnack(true);
        }

      } catch (e) {
        setCnpjConfirmation('');
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
        setShowMessageSnack(true);
      }

    }
  }

  function onCancelDeleteFiliado() {
    setSelectedIndexFiliado(-1);
    setShowDialogConfirmacaoDeleteFiliado(false)
  }

  async function filterFiliados(filterValue, date01, date02, idFiliacaoStatus) {
    try {
      setLoading(true);
      const params = {
        limit: 100,
        nome: filterValue,
        cpf: filterValue,
        numeroCr: filterValue,
        dataInicialValidadeAnuidade: date01,
        dataFinalValidadeAnuidade: date02,
        idFiliacaoStatus: idFiliacaoStatus
      };
      const dados = await api.get('filiados/filter', { params: params });
      setLoading(false);
      if (dados.data.isSuccess) {
        for (let i = 0, size = dados.data.result.length; i < size; i++) {
          dados.data.result[i].on_mouse_over = false;
        }
        setFiliados(dados.data);
      } else {
      }

    } catch (e) {
      console.log(e.toString())
    }
  }

  function openFiliadoRegister(event) {
    event.preventDefault();
    const filiado = {
      codigo: undefined,
      nome: undefined,
      rg: undefined,
      orgaoExpedidor: undefined,
      dataExpedicao: null,
      cpf: undefined,
      dataNascimento: undefined,
      estadoCivil: null,
      profissao: '',
      nomeMae: '',
      nomePai: '',
      email: undefined,
      numeroCr: undefined,
      validadeCr: null,
      validadeAnuidade: null,
      idFiliacaoStatus: '',
      idGrupoSanguineo: null,
      enderecos: [],
      telefones: [],
      visitas: [],
      naturalidade: null,
      observacoes: [],
      imagem: null,
      idImagem: null
    };
    history.push('/filiado-register/', {filiado: filiado, edicao: false});
  }


  async function downloadPDF(index) {
    try{
      setLoading(true);
      const params = {
        idFiliado: filiados.result[index].idFiliado
      };
      const response = await api.get('relatorio/relatorio-ficha-filiado/',
        {
          params: params,
          responseType: 'blob'
        });

      setLoading(false);
      const file = new Blob(
        [response.data],
        {type: 'application/pdf'});
      const fileURL = window.URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', `proposta_filiacao.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      // let a = document.createElement('a');
      // a.href = fileURL;
      // a.open = fileURL;
      // a.click();
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
      setShowMessageSnack(true);
    }
  }


  async function openFiliadoEdit(index) {
    try{
      if (index < 0 && index >= filiados.result.length) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível editar o usuário');
        setShowMessageSnack(true);
      } else {
        setLoading(true);
        const dados = await api.get(`filiados/${filiados.result[index].idFiliado}`);
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length > 0){
            history.push('/filiado-edit/', {filiado: dados.data.result[0], edicao: true});
          }
          else{
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há filiados cadastrados.');
            setShowMessageSnack(true);
          }
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Ocorreu um erro ao obter dados do usuário.');
          setShowMessageSnack(true);
        }
      }
    }
    catch (e) {
      console.log(e.toString());
      // setSucess(false);
    }
  }

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function handleAbrirDialogImpressao(event) {
    event.preventDefault();
    setAbrirDialogImpressao(true);
  }


  return (
    sucess
    ?
      <Grid
        container
        className={classes.root}
      >
        <Grid
          md={12}
          xs={12}
          style={{
            zIndex: 3
          }}
        >
          <Backdrop open={open} />
        </Grid>
        <Grid
          md={12}
          xs={12}
        >
          <FiliadoToolbar
            filterFiliados={filterFiliados}
            filiacaoStatus={filiacaoStatus}
          />
        </Grid>
        <Grid
          md={12}
          xs={12}
        >
          <SnackbarCustom
            verticalOrientation='bottom'
            horizontalOrientation='center'
            open={showMessageSnack}
            setOpen={setShowMessageSnack}
            message={messageSnack}
            duration={2000}
            type={typeSnack}
          />
        </Grid>
        <Grid
          md={12}
          xs={12}
        >
          <Dialog open={showDialogConfirmacaoDeleteFiliado} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Remoção de filiado</DialogTitle>
            <DialogContent>
              <Typography gutterBottom>
                Você está tentando deletar o filiado com as seguintes informações:
              </Typography>
              <Typography
                gutterBottom
                style={{marginTop: '30px'}}
              >
                {selectedIndexFiliado < 0 || selectedIndexFiliado >= filiados.result.length ? '' :
                  'Nome: ' + filiados.result[selectedIndexFiliado].nome
                }
              </Typography>
              <Typography
                gutterBottom

              >
                {selectedIndexFiliado < 0 || selectedIndexFiliado >= filiados.result.length ? '' :
                  'CPF: ' + filiados.result[selectedIndexFiliado].cpf
                }
              </Typography>
              <Typography
                gutterBottom
                style={{marginBottom: '30px'}}
              >
                {selectedIndexFiliado < 0 || selectedIndexFiliado >= filiados.result.length ? '' :
                  'Número CR: ' + filiados.result[selectedIndexFiliado].numeroCr
                }
              </Typography>
              <Typography gutterBottom>
                Tem certeza que deseja excluir esse usuário?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={onCancelDeleteFiliado} color="primary">
                Cancel
              </Button>
              <Button onClick={deleteFiliado} color="primary">
                Confirmar
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
        <Grid
          md={12}
          xs={12}
        >
          <ProgressFullScreen
            open={loading}
            setOpen={setLoading}
          />
        </Grid>
        <Grid
          md={12}
          xs={12}
        >
          <Grid
            container
          >
            <Grid
              md={12}
              xs={12}
            >
              <DialogImpressao
                filiacaoStatus={filiacaoStatus.result}
                open={abrirDialogImpressao}
                setOpen={setAbrirDialogImpressao}
                setShowMessageSnack={setShowMessageSnack}
                setMessageSnack={setMessageSnack}
                setTypeSnack={setTypeSnack}
                setLoading={setLoading}
              />
            </Grid>
            <Grid
              md={12}
              xs={12}
            >
              <div className={classes.content}>
                <FiliadoTable
                  filiados={filiados}
                  setFiliados={setFiliados}
                  deleteFiliado={showConfirmationDeleteFiliado}
                  editFiliado={openFiliadoEdit}
                  downloadPDF={downloadPDF}
                  showMessageSnack={showMessageSnack}
                  setShowMessageSnack={setShowMessageSnack}
                  messageSnack={messageSnack}
                  setMessageSnack={setMessageSnack}
                  typeSnack={typeSnack}
                  setTypeSnack={setTypeSnack}
                />
              </div>
            </Grid>

          </Grid>
        </Grid>
        <Grid
          md={12}
          xs={12}
        >
          <div
            className={classes.divFab}
          >
            <SpeedDial
              ariaLabel="Mais Opções"
              className={classes.fab}
              icon={<MoreVertIcon />}
              onClose={handleClose}
              onOpen={handleOpen}
              open={open}
            >
              {opcoesBotaoFlutuante.map((action) => (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  tooltipTitle={action.name}
                  tooltipOpen
                  onClick={e => action.acao(e)}
                  title={action.name}
                />
              ))}
            </SpeedDial>
            {/*<Fab*/}
            {/*  aria-label={'Add'}*/}
            {/*  className={classes.fab}*/}
            {/*  color={'primary'}*/}
            {/*  variant={'round'}*/}
            {/*  onClick={openFiliadoRegister}*/}
            {/*>*/}
            {/*  <AddIcon />*/}
            {/*</Fab>*/}
          </div>
        </Grid>
      </Grid>
      :
      <NotFoundView/>

  );
};

export default FiliadoList;
